export const authenticationProviderSupportedType = {
  Legacy: 1,
  Oidc: 2,
};
